// ActionButton.jsx - Updated with disabled buttons, Complete Outsource, and Create New Case
// FIX: Dropdown menu now stays contained within the viewport (no overflow outside screen),
// is more compact, and wraps long text instead of cutting it off / spilling out.
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPencilAlt } from "react-icons/fa";
import React, { useState, useRef, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link, useParams, useLocation } from "react-router-dom";
import ProcedureModel from "./addprocedure";
import AddExternallyLink from "./addExternallyLink";
import Edittask from "./editTask";
import CloseCase from "./closeCase";
import ShowData from "./showData";
import Outsource from "../OutSource";
import AddOutsourceShipmentTracking from "./addOutsourceShipmentTracking";
import ChangeOnHold from "./changeOnHold";
import InternalRemakeCase from "./internalRemakeCase";
import AddExternalycase from "./addExternalyCase";
import CancelCaseModal from "./CancelCaseModal";
import DraftInvoice from "../draftInvoice";
import ChangeAccount from "../changeAccount";
import CreateNewCaseModal from "./CreateNewCaseModal"; // Import the new component
import { Modal, Button, Spinner, Alert } from "react-bootstrap";
import "./buttons.css"; // NEW: separate CSS file for the dropdown fix

// Pricing access hook — gates the Draft Invoice entry
import usePricingAccess from "../../../../../../hooks/usePricingAccess";

function ActionButton({ caseId: propCaseId, caseNumber: propCaseNumber, initialArrived, onTryInUpdate, onStatusUpdate, currentCase }) {
  const { caseId: urlCaseId } = useParams();
  const location = useLocation(); // Added useLocation to check current URL

  const caseId = propCaseId || urlCaseId;
  const [caseNumber, setCaseNumber] = useState(propCaseNumber || '');

  // Pricing access — Admins are automatically granted by the hook,
  // non-admins get it from the backend flag.
  const { hasPricingAccess } = usePricingAccess();

  const [showInternalModal, setShowInternalModal] = useState(false);
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [showSourceModal, setShowSourceModal] = useState(false);
  const [showOutsourceModal, setShowOutsourceModal] = useState(false);
  const [showDataModel, setShowDataModel] = useState(false);
  const [showCloseModel, setShowCloseModel] = useState(false);
  const [showExternallyData, setShowExternallyData] = useState(false);
  const [showEditTask, setShowEditTask] = useState(false);
  const [showExternallyLink, setShowExternallyLink] = useState(false);
  const [showAddProcedure, setShowAddProcedure] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showChangeAccountModal, setShowChangeAccountModal] = useState(false);
  const [showCompleteOutsourceModal, setShowCompleteOutsourceModal] = useState(false);
  const [showCreateNewCaseModal, setShowCreateNewCaseModal] = useState(false); // New state
  const [isArrived, setIsArrived] = useState(initialArrived);
  const [isTryIn, setIsTryIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [visiblePages, setVisiblePages] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showDraftInvoice, setShowDraftInvoice] = useState(false);
  const [completingOutsource, setCompletingOutsource] = useState(false);
  const [completeOutsourceError, setCompleteOutsourceError] = useState("");
  const [completeOutsourceSuccess, setCompleteOutsourceSuccess] = useState("");

  // Check if current page is outsource case page
  const isOutsourceCasePage = location.pathname.startsWith('/outsource-case/');

  // Style for disabled buttons
  const disabledStyle = {
    padding: "6px 12px",
    color: "#999",
    pointerEvents: "none",
    opacity: 0.5,
    cursor: "not-allowed",
    fontSize: "13px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  };

  // Style for enabled buttons
  const enabledStyle = {
    padding: "6px 12px",
    color: "#004aad",
    transition: "background-color 0.2s",
    fontWeight: "700",
    fontSize: "13px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  };

  // Build current case object for the modal
  const currentCaseObject = {
    id: caseId,
    caseNumber: caseNumber,
    patientName: currentCase?.patientName || currentCase?.patient_name || 'Unknown Patient'
  };

  // Fetch case data
  useEffect(() => {
    const fetchCaseDetails = async () => {
      if (!caseId) return;

      try {
        const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/cases/${caseId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (response.ok) {
          const caseData = await response.json();
          if (!propCaseNumber && caseData.caseNumber) {
            setCaseNumber(caseData.caseNumber);
          }
          setIsArrived(!!caseData.arrive_date);
          setIsTryIn(!!caseData.try_in);
        }
      } catch (error) {
        console.error("Error fetching case details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (caseId) {
      fetchCaseDetails();
    } else {
      console.error("No caseId provided to ActionButton");
      setIsLoading(false);
    }
  }, [caseId, propCaseNumber]);

  // Get user data
  const getUserData = () => {
    try {
      const possibleKeys = ['user', 'userData', 'auth', 'currentUser', 'labUser', 'labUserData'];

      for (const key of possibleKeys) {
        const storedData = localStorage.getItem(key);
        if (storedData) {
          try {
            const parsed = JSON.parse(storedData);

            const userRole =
              parsed.userRole ||
              parsed.role ||
              parsed.data?.userRole ||
              parsed.data?.role ||
              parsed.user?.userRole ||
              parsed.user?.role;

            if (userRole) {
              return {
                userRole: userRole,
                userId: parsed.userId || parsed.id || parsed.data?.userId || parsed.data?.id
              };
            }
          } catch (e) {
            continue;
          }
        }
      }

      return { userRole: null, userId: null };
    } catch (error) {
      return { userRole: null, userId: null };
    }
  };

  useEffect(() => {
    const userData = getUserData();
    const adminStatus = userData.userRole === "Admin" || userData.userRole === "admin";

    setUserRole(userData.userRole);
    setIsAdmin(adminStatus);

    if (!adminStatus && userData.userId) {
      const fetchPermissions = async () => {
        try {
          const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/page/user/${userData.userId}/pages`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });

          if (!response.ok) {
            throw new Error("Failed to fetch permissions");
          }

          const data = await response.json();

          if (data && Array.isArray(data)) {
            const pageNames = data.map((perm) => perm.page?.name || perm.pageName).filter(Boolean);
            setVisiblePages(pageNames);
          }
        } catch (error) {
          console.error("Error fetching permissions:", error);
        }
      };
      fetchPermissions();
    }
  }, []);

  const shouldShowPage = (pageName) => {
    if (isAdmin) {
      return true;
    }
    return visiblePages.includes(pageName);
  };

  const handleToggleArrive = async () => {
    if (!caseId) return;
    try {
      setIsLoading(true);
      const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/cases/${caseId}/arrive-status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ arrived: !isArrived }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update arrive status");
      }
      setIsArrived(!isArrived);
    } catch (error) {
      console.error("Error updating arrive status:", error);
      alert(`Error updating arrive status: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMarkAsTryIn = async () => {
    if (!caseId) return;
    const newTryIn = !isTryIn;
    try {
      const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/cases/${caseId}/try-in`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ try_in: newTryIn }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update Try In status");
      }
      setIsTryIn(newTryIn);
      onTryInUpdate(newTryIn);
      alert(newTryIn ? "Case marked as Try In successfully" : "Case unmarked as Try In successfully");
    } catch (error) {
      console.error("Error updating Try In status:", error);
      alert(`Error updating Try In status: ${error.message}`);
    }
  };

  const handleCancelCase = async (reason) => {
    const cancelCaseNumber = caseNumber || caseId;
    if (!cancelCaseNumber) {
      alert("Error: Case number is missing");
      return;
    }
    try {
      const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/cases/cancel/${cancelCaseNumber}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ cancellationReason: reason }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to cancel case");
      }
      const updatedCase = await response.json();
      onStatusUpdate(updatedCase.case);
      alert("Case canceled successfully");
      window.location.href = "/cases-cancelled-report";
    } catch (error) {
      console.error("Error canceling case:", error);
      alert(`Error canceling case: ${error.message}`);
    }
  };

  const handleCancelAndCloneCase = () => {
    if (!caseId) return;
    if (window.confirm("Are you sure you want to cancel and clone this case?")) {
      window.location.href = "/accountDetails";
    }
  };

  const handleChangeAccount = async (newAccountData) => {
    try {
      const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/cases/${caseId}/change-account`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(newAccountData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to change account");
      }

      const updatedCase = await response.json();
      onStatusUpdate(updatedCase.case);
      alert("Account changed successfully");
      setShowChangeAccountModal(false);
    } catch (error) {
      console.error("Error changing account:", error);
      alert(`Error changing account: ${error.message}`);
    }
  };

  const handleAccountChangeConfirm = (data) => {
    if (onStatusUpdate) {
      onStatusUpdate(data.updatedCase);
    }
    setShowChangeAccountModal(false);
    alert("Account and prices updated successfully!");
  };

  const handleCompleteOutsource = async () => {
    // Use the caseNumber that was passed as prop
    const outsourceCaseNumber = caseNumber || propCaseNumber;

    if (!outsourceCaseNumber) {
      setCompleteOutsourceError("Case number is missing. Cannot complete outsource.");
      console.error('❌ No caseNumber available. Props:', { caseNumber, propCaseNumber });
      return;
    }

    setCompletingOutsource(true);
    setCompleteOutsourceError("");
    setCompleteOutsourceSuccess("");

    try {
      const userLabId = localStorage.getItem('userLabId');
      const token = localStorage.getItem('token') || localStorage.getItem('accessToken');

      // Clean the caseNumber
      const cleanCaseNumber = String(outsourceCaseNumber).trim();

      const url = `https://hms.backend.hiragroupcloud.com/api/outsource-case/complete/${cleanCaseNumber}`;

    

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
          "userLabId": userLabId || ''
        }
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setCompleteOutsourceSuccess(`Outsource case #${cleanCaseNumber} completed successfully!`);

        if (onStatusUpdate) {
          onStatusUpdate(result.data);
        }

        setTimeout(() => {
          setShowCompleteOutsourceModal(false);
          setCompleteOutsourceSuccess("");
          // Optionally reload the page to reflect changes
          window.location.reload();
        }, 2000);
      } else {
        setCompleteOutsourceError(result.message || "Failed to complete outsource case");
      }
    } catch (error) {
      console.error("❌ Error:", error);
      setCompleteOutsourceError("Network error: " + error.message);
    } finally {
      setCompletingOutsource(false);
    }
  };

  const fileInputRef = useRef(null);
  const handleUploadClick = () => fileInputRef.current.click();
  const handleFileChange = (event) => console.log(event.target.files);

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle
          variant="primary"
          className="d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "#004aad",
            borderColor: "#004aad",
            color: "#ffffff",
            padding: "8px 16px",
            fontSize: "14px",
            borderRadius: "5px",
            transition: "all 0.3s ease",
          }}
          id="dropdown-basic"
          disabled={isLoading}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#003a8c")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#004aad")}
        >
          <FaPencilAlt className="me-2" /> {isLoading ? "Loading..." : "Actions"}
        </Dropdown.Toggle>
        {/*
          FIX: className="action-dropdown-menu" (styles in ActionButton.css) +
          popperConfig with the "preventOverflow" / "flip" modifiers keeps the
          menu clamped inside the viewport instead of spilling off the screen.
        */}
        <Dropdown.Menu
          className="shadow-lg action-dropdown-menu"
          renderOnMount
          popperConfig={{
            strategy: "fixed",
            modifiers: [
              {
                name: "preventOverflow",
                options: {
                  boundary: "viewport",
                  padding: 8,
                },
              },
              {
                name: "flip",
                options: {
                  fallbackPlacements: ["top-start", "bottom-end", "top-end"],
                },
              },
            ],
          }}
        >
          {/* Create New Case - NEW BUTTON */}
          <Dropdown.Item
            onClick={() => setShowCreateNewCaseModal(true)}
            style={{
              ...enabledStyle,
              backgroundColor: '#e8f0fe',
              fontWeight: 'bold'
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#d4e3fd")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#e8f0fe")}
          >
            Create New Case From #{caseNumber || 'Current'}
          </Dropdown.Item>

          <hr className="dropdown-divider my-1" />

          {/* Arrive Case - ENABLED */}
          <Dropdown.Item
            onClick={handleToggleArrive}
            disabled={isLoading}
            style={enabledStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            {isArrived ? "Un-Arrive Case" : "Arrive Case"}
          </Dropdown.Item>

          {/* Mark As Try In - ENABLED */}
          <Dropdown.Item
            onClick={handleMarkAsTryIn}
            style={enabledStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            {isTryIn ? "Mark As Not Try In" : "Mark As Try In"}
          </Dropdown.Item>

          {/* Change On Hold Status - ENABLED */}
          <Dropdown.Item
            onClick={() => setShowChangeModal(true)}
            style={enabledStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            Change On Hold Status
          </Dropdown.Item>

          <hr className="dropdown-divider my-1" />

          {/* Add Outsource - ENABLED */}
          <Dropdown.Item
            onClick={() => {
              setShowOutsourceModal(true);
            }}
            style={enabledStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            Add Outsource
          </Dropdown.Item>

          {/* Complete Outsource - ONLY VISIBLE ON OUTSOURCE CASE PAGE */}
          {isOutsourceCasePage && (
            <Dropdown.Item
              onClick={() => setShowCompleteOutsourceModal(true)}
              style={enabledStyle}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
            >
              Complete Outsource ✅
            </Dropdown.Item>
          )}

          {/* Draft Invoice — ONLY when user is Admin OR has pricing access */}
          {hasPricingAccess && (
            <Dropdown.Item
              onClick={() => setShowDraftInvoice(true)}
              style={enabledStyle}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
            >
              Draft Invoice
            </Dropdown.Item>
          )}

          <hr className="dropdown-divider my-1" />

          {/* Print Work Ticket - ENABLED */}
          <Dropdown.Item
            as={Link}
            to={`/workticket/${caseId}`}
            style={enabledStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            Print Work Ticket
          </Dropdown.Item>

          {/* Print Work Ticket Sticker - ENABLED */}
          <Dropdown.Item
            as={Link}
            to={`/sticker/${caseId}`}
            style={enabledStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            Print Work Ticket Sticker
          </Dropdown.Item>

          <hr className="dropdown-divider my-1" />

          {/* Cancel Case - ENABLED */}
          <Dropdown.Item
            onClick={() => setShowCancelModal(true)}
            style={enabledStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            Cancel Case
          </Dropdown.Item>

          {/* Cancel and Clone Case - ENABLED */}
          <Dropdown.Item
            onClick={handleCancelAndCloneCase}
            style={enabledStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            Cancel and Clone Case
          </Dropdown.Item>

          <hr className="dropdown-divider my-1" />

          {/* Change Account - ENABLED */}
          <Dropdown.Item
            onClick={() => setShowChangeAccountModal(true)}
            style={enabledStyle}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            Change Account
          </Dropdown.Item>

          <hr className="dropdown-divider my-1" />

          {/* DISABLED BUTTONS BELOW */}

          {/* Internal Remake Case - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Internal Remake Case
          </Dropdown.Item>

          {/* Add Note - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Add Note
          </Dropdown.Item>

          {/* Add Outsource Shipment Tracking - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Add Outsource Shipment Tracking
          </Dropdown.Item>

          {/* Show Data - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Show Data
          </Dropdown.Item>

          {/* Close/Invoice Case - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Close/Invoice Case
          </Dropdown.Item>

          {/* Upload Files - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Upload Files
          </Dropdown.Item>

          {/* Add Externally Linked File - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Add Externally Linked File
          </Dropdown.Item>

          {/* Edit Task - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Edit Task
          </Dropdown.Item>

          {/* Add Procedure - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Add Procedure
          </Dropdown.Item>

          {/* Add Externally Linked Case - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Add Externally Linked Case
          </Dropdown.Item>

          {/* Clone Case - DISABLED */}
          <Dropdown.Item style={disabledStyle}>
            Clone Case
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <CreateNewCaseModal
        show={showCreateNewCaseModal}
        onHide={() => setShowCreateNewCaseModal(false)}
        caseId={caseId}
        caseNumber={caseNumber}
        currentCase={currentCaseObject}
      />

      {/* Complete Outsource Confirmation Modal */}
      <Modal
        show={showCompleteOutsourceModal}
        onHide={() => {
          setShowCompleteOutsourceModal(false);
          setCompleteOutsourceError("");
          setCompleteOutsourceSuccess("");
        }}
        centered
        size="md"
      >
        <Modal.Header closeButton style={{ backgroundColor: "#28a745", color: "white" }}>
          <Modal.Title style={{ fontWeight: "600" }}>
            ✅ Complete Outsource Case
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "25px" }}>
          {completeOutsourceError && (
            <Alert variant="danger" onClose={() => setCompleteOutsourceError("")} dismissible>
              {completeOutsourceError}
            </Alert>
          )}
          {completeOutsourceSuccess && (
            <Alert variant="success" onClose={() => setCompleteOutsourceSuccess("")} dismissible>
              {completeOutsourceSuccess}
            </Alert>
          )}

          {!completeOutsourceSuccess && (
            <>
              <div style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffc107",
                borderRadius: "5px",
                padding: "15px",
                marginBottom: "15px"
              }}>
                <p style={{ margin: "0", fontSize: "15px", color: "#856404" }}>
                  <strong>⚠️ Important:</strong> You are about to mark this outsource case as completed.
                </p>
              </div>

              <div style={{ backgroundColor: "#f8f9fa", padding: "15px", borderRadius: "5px" }}>
                <p style={{ margin: "0 0 10px 0", fontSize: "16px" }}>
                  <strong>Case Number:</strong> {caseNumber || 'N/A'}
                </p>
                {caseId && (
                  <p style={{ margin: "0 0 10px 0", fontSize: "14px", color: "#666" }}>
                    <strong>Case ID:</strong> {caseId}
                  </p>
                )}
                <p style={{ margin: "0", color: "#666", fontSize: "14px" }}>
                  This action will mark the outsource case as completed and notify the other party.
                  This cannot be undone.
                </p>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowCompleteOutsourceModal(false);
              setCompleteOutsourceError("");
              setCompleteOutsourceSuccess("");
            }}
            disabled={completingOutsource}
          >
            Cancel
          </Button>
          {!completeOutsourceSuccess && (
            <Button
              variant="success"
              onClick={handleCompleteOutsource}
              disabled={completingOutsource || !caseNumber}
              style={{ minWidth: "140px" }}
            >
              {completingOutsource ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    style={{ marginRight: "8px" }}
                  />
                  Completing...
                </>
              ) : (
                "Complete Outsource ✅"
              )}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* Existing Modals */}
      <InternalRemakeCase
        showModal={showInternalModal}
        handleClose={() => setShowInternalModal(false)}
      />
      <ChangeOnHold
        caseId={caseId}
        showModal={showChangeModal}
        handleClose={() => setShowChangeModal(false)}
      />
      <AddOutsourceShipmentTracking
        showModal={showSourceModal}
        handleClose={() => setShowSourceModal(false)}
      />
      <ShowData
        showModal={showDataModel}
        handleClose={() => setShowDataModel(false)}
      />
      <CloseCase
        showModal={showCloseModel}
        handleClose={() => setShowCloseModel(false)}
      />
      <AddExternalycase
        showModal={showExternallyData}
        handleClose={() => setShowExternallyData(false)}
      />
      <Edittask
        showModal={showEditTask}
        handleClose={() => setShowEditTask(false)}
      />
      <ProcedureModel
        showModal={showAddProcedure}
        handleClose={() => setShowAddProcedure(false)}
      />
      <AddExternallyLink
        showModal={showExternallyLink}
        handleClose={() => setShowExternallyLink(false)}
      />

      <CancelCaseModal
        show={showCancelModal}
        handleClose={() => setShowCancelModal(false)}
        handleConfirm={handleCancelCase}
        caseNumber={caseNumber || caseId}
      />

      <ChangeAccount
        show={showChangeAccountModal}
        handleClose={() => setShowChangeAccountModal(false)}
        caseNumber={caseNumber || caseId}
        handleConfirm={handleAccountChangeConfirm}
      />

      <Outsource
        showModal={showOutsourceModal}
        handleClose={() => setShowOutsourceModal(false)}
        caseId={caseId}
        caseNumber={caseNumber || caseId}
      />

      {showDraftInvoice && (
        <DraftInvoice
          show={showDraftInvoice}
          onHide={() => setShowDraftInvoice(false)}
          caseId={caseId}
          caseNumber={caseNumber}
        />
      )}

      <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
    </>
  );
}

export default ActionButton;